import cs from './locales/cs.json';
import de from './locales/de.json';
import english from './locales/en.json';
import es from './locales/es.json';
import id from './locales/id.json';
import it from './locales/it.json';
import nl from './locales/nl.json';
import sv from './locales/sv.json';
import vi from './locales/vi.json';
import zhHans from './locales/zh-hans.json';
import type { PublicLocale } from './locales';

export type PublicMessage = keyof typeof english;
export type PublicMessages = Record<PublicMessage, string>;
export const englishMessages: PublicMessages = english;

function requireCatalog(value: unknown): PublicMessages {
  if (typeof value !== 'object' || value === null) {
    throw new Error('Incomplete public translation');
  }
  const entries = Object.entries(value);
  const messages: Record<string, string> = {};
  for (const key of Object.keys(english)) {
    const found = entries.find(([name]) => name === key)?.[1];
    if (typeof found !== 'string' || !found.trim()) {
      throw new Error('Incomplete public translation');
    }
    messages[key] = found;
  }
  return messages as PublicMessages;
}

/** Every public locale is loaded with the page, so a language change does not wait on the network. */
export const publicCatalogs: Record<PublicLocale, PublicMessages> = {
  cs: requireCatalog(cs),
  de: requireCatalog(de),
  en: englishMessages,
  es: requireCatalog(es),
  id: requireCatalog(id),
  it: requireCatalog(it),
  nl: requireCatalog(nl),
  sv: requireCatalog(sv),
  vi: requireCatalog(vi),
  'zh-hans': requireCatalog(zhHans),
};

export function translator(messages: PublicMessages) {
  return (text: string): string =>
    messages[text as PublicMessage] ||
    (text.endsWith(' | Revelationary')
      ? `${messages[text.slice(0, -16) as PublicMessage] || text.slice(0, -16)} | Revelationary`
      : text);
}
export function loadPublicMessages(locale: PublicLocale): Promise<PublicMessages> {
  return Promise.resolve(publicCatalogs[locale]);
}
